<div class="boondocking-poi-card">
  <div class="boondocking-poi-outer">
    <div>
      <div class="boondocking-poi-info-outer">
        <div class="trip-planner-image" [ngStyle]="{ 'background-image': 'url(' + photoUrl + ')' }"></div>
        <div class="boondocking-poi-info-inner">
          <div class="poi-boondocking-name-inner">
            <div class="site-name">{{ point?.name }}</div>
            <div class="location-copy">{{ point?.location }}</div>
          </div>
          <div class="poi-outer">
            <div *ngIf="false" class="svg-icon">
              <curbnturf-category-svg icon="activity"> </curbnturf-category-svg>
            </div>
            <div *ngIf="false" class="svg-icon">
              <curbnturf-category-svg icon="dump"> </curbnturf-category-svg>
            </div>
            <div *ngIf="false" class="svg-icon">
              <curbnturf-category-svg icon="restArea"> </curbnturf-category-svg>
            </div>
            <div *ngIf="false" class="svg-icon">
              <curbnturf-category-svg icon="wifi"> </curbnturf-category-svg>
            </div>
            <div *ngIf="false" class="svg-icon">
              <curbnturf-category-svg icon="potableWater"> </curbnturf-category-svg>
            </div>
            <div *ngIf="false" class="svg-icon">
              <curbnturf-category-svg icon="propane"> </curbnturf-category-svg>
            </div>
          </div>
        </div>
      </div>
      <div class="poi-add-fav-outer">
        <div class="favorite-outer" (click)="onFavorite($event)">
          <ion-icon [name]="favorite ? 'heart' : 'heart-outline'" color="orange"></ion-icon>
        </div>
        <div class="cnt-button trip" (click)="onAddToTrip($event)" *ngIf="!addedToTrip">
          <div class="cnt-button-icon">
            <div class="html-embed w-embed">
              <curbnturf-site-svgs type="rvtrip"></curbnturf-site-svgs>
            </div>
          </div>
          <div class="cnt-button-copy">Add To Trip</div>
        </div>
        <div class="cnt-button trip" (click)="onRemoveFromTrip($event)" *ngIf="addedToTrip">
          <div class="cnt-button-icon">
            <div class="html-embed w-embed">
              <curbnturf-site-svgs type="rvtrip"></curbnturf-site-svgs>
            </div>
          </div>
          <div class="cnt-button-copy">Remove From Trip</div>
        </div>
      </div>
    </div>
  </div>
</div>
